import { useLocale } from '@dreamstack/i18n'
import { trpc } from '@dreamstack/trpc/client'
import filter from 'lodash/filter'
import orderBy from 'lodash/orderBy'
import { useMemo } from 'react'

export const useNavBarEntries = (type: 'TopNav' | 'Footer') => {
  const locale = useLocale()
  const { data } = trpc.cms.getNavEntries.useQuery({ locale })
  return useMemo(() => {
    let entries = data
    if (!entries) return []

    entries = filter(entries, (e) => e.navType === type)
    entries = orderBy(entries, (e) => e.position)

    return entries
  }, [data, type])
}
